import { Component } from '@angular/core';

/**
 * Filtros SVG compartilhados, referenciados no CSS por url('#id'). Incluir UMA vez no app.component.html de cada app.
 * - agj-wordmark-on-dark: a Lottie da marca (agenda-ja-loading-loop.json) é raster; no escuro troca #4C4C4C ("Agenda")
 *   por #E6E6E6 e #8200FF ("Já!") por #B166FF (Anexo H.6.4). Usa só o canal B; recalcular se a animação mudar.
 * Fica fora da tela com tamanho zero, nunca com display: none (o Firefox ignora filtro dentro de SVG com display: none).
 */
@Component({
  selector: 'agj-one-svg-defs',
  template: `
    <svg class="agj-one-svg-defs" width="0" height="0" aria-hidden="true" focusable="false">
      <filter id="agj-wordmark-on-dark" x="0" y="0" width="100%" height="100%" color-interpolation-filters="sRGB">
        <feColorMatrix type="matrix" values="0 0 -0.2961 0 0.9902  0 0 -0.7151 0 1.1151  0 0 0.1397 0 0.8603  0 0 0 1 0" />
      </filter>
    </svg>
  `,
  styles: [
    `
      :host,
      .agj-one-svg-defs {
        position: absolute;
        width: 0;
        height: 0;
        overflow: hidden;
      }
    `
  ]
})
export class OneSvgDefsComponent {}
